import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-print',
    templateUrl: './icon-print.component.html',
    styleUrls: ['./icon-print.component.scss']
})
export class IconPrintComponent implements OnInit {

    @Input() cssClass = '';

    constructor() { }

    ngOnInit() {
    }

}
